import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Record from './pages/pc/record'
import History from './pages/pc/history'
import Success from './pages/pc/success'
import Entry from './pages/pc/entry'
import MobileService from './pages/m/mobile-service'

import Page404 from './pages/404'
import Demo from './pages/demo'

function App() {
  return (
    <Switch>
      <Route path="/record">
        <Record></Record>
      </Route>
      <Route path="/history">
        <History></History>
      </Route>
      <Route path="/success">
        <Success></Success>
      </Route>
      <Route path="/entry">
        <Entry></Entry>
      </Route>
      <Route path="/ms">
        <MobileService></MobileService>
      </Route>
      <Route path="/demo">
        <Demo></Demo>
      </Route>
      <Route>
        <Page404 />
      </Route>
    </Switch>
  )
}

export default App
